import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiAbstraction } from './api.abstraction';
import { Observable } from 'rxjs';

@Injectable()
export class DetectedAdditionalAssetApi extends ApiAbstraction {
  public constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  public markRelatedUrlsProcessed(
    unitId: ID,
    assetId: ID,
    jobId: ID,
    body: MarkRelatedUrlsProcessedDAO
  ): Observable<unknown> {
    return this.httpClient.patch(
      `${this.baseUrl}/ai/units/${unitId}/assets/${assetId}/extraction-job/${jobId}/mark-related-urls-processed`,
      { ...body }
    );
  }
}
